module.exports = __webpack_public_path__ + "static/media/logoOnlyInverse.0585cb7a.svg";